export const formatChar = (char: string): any => {
  return char
    .trim()
    .replace(/[@$%^()+=/"<>|]/g, '')
    .replace(/  +/g, ' ');
};
